// extracted by mini-css-extract-plugin
export var customerCardCurtain = "customerListingCard-module--customerCardCurtain--64cda";
export var customerCardImage = "customerListingCard-module--customerCardImage--01ec8";
export var customerLink = "customerListingCard-module--customerLink--35b76";
export var customerListingCardContent = "customerListingCard-module--customerListingCardContent--59e0f";
export var customerListingCardLogo = "customerListingCard-module--customerListingCardLogo--53908";
export var readMore = "customerListingCard-module--readMore--e2d53";